/**
 * Cidara Flu Prevention Study - Self-Contained Module
 *
 * This module contains all configuration for the Cidara Flu Prevention Study
 * in a single, easily maintainable location.
 */

import { defineStudy } from "./registry";
import { cidaraEligibleZipCodes } from "../../../data/vaccine-study-zipcodes/cidaraZipCodes";
import { cidaraFluVaxScreeningQuestions } from "../../../data/pre-screener-config/CidaraFluVaxScreener";

/**
 * Common question IDs that will be asked before zipcode
 * and should be filtered out of study-specific questions
 */
const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Cidara Flu Prevention Study
 *
 * Priority: 1 (Highest - checked first)
 * Trial ID: VFLUSQ30665
 * Location: Specific zipcodes in multiple states
 *
 * Key criteria:
 * - Age 65+
 * - BMI >= 18
 * - No recent influenza diagnosis
 * - No major exclusionary conditions
 */
export const cidaraFluPreventionStudy = defineStudy({
  id: "cidara",
  name: "Cidara Flu Prevention Study",
  trialId: "VFLUSQ30665",
  priority: 1,

  // Convert readonly array to regular array for compatibility
  eligibleZipCodes: Array.from(cidaraEligibleZipCodes),

  // All questions including common ones (will be filtered automatically)
  questions: cidaraFluVaxScreeningQuestions,

  // Questions to filter out (already asked in common stage)
  commonQuestionIds: COMMON_QUESTION_IDS,

  // Required common answer values (age 65+)
  commonAnswerRequirements: {
    age_eligibility: ["65_or_older"],
  },

  metadata: {
    sponsor: "Cidara Therapeutics",
    description:
      "Investigating an investigational medication designed to prevent influenza in adults aged 65 and older",
  },
});
